import { HttpContextToken } from '@angular/common/http';

export const SKIP_COMPANY_ID = new HttpContextToken<boolean>(() => false);
export const COMPANY_ID_OVERRIDE = new HttpContextToken<string | null>(() => null);

export function isCompanyDetailsV2Path(path: string | null | undefined): boolean {
  return /^\/company-v2(?:\/|$)/.test((path || '').split(/[?#]/)[0]);
}
